import { generatePath } from "react-router";
import { FlameOutline } from "@acto/web-common/components";
import { useTranslations } from "@acto/web-common/locales";
import { useDirectionalNavigate } from "@acto/taskpane/field-sales-2/utils/viewTransitions";
import { NudgeBanner } from "@acto/taskpane/field-sales-2/components/patterns/NudgeBanner";
import ActoRoutes from "@acto/taskpane/core/router/routes.config";

interface MeetingPrepEntryBannerProps {
  clientId: string;
  /** Headline of the first prepared story; the banner is hidden until one exists. */
  storyHeadline?: string;
  className?: string;
}

/**
 * Entry point into the customer's Vorbereiten (meeting prep) page, teasing the
 * first prepared story.
 */
export function MeetingPrepEntryBanner({ clientId, storyHeadline, className }: MeetingPrepEntryBannerProps) {
  const t = useTranslations("fieldSalesTwo.meetingPrep");
  const navigate = useDirectionalNavigate();

  if (!storyHeadline) {
    return null;
  }

  return (
    <NudgeBanner
      className={className}
      icon={<FlameOutline width={22} height={22} aria-hidden="true" />}
      label={t("entryBanner")}
      subLabel={storyHeadline}
      onClick={() => navigate(generatePath(ActoRoutes.MEETING_PREP, { id: clientId }), { direction: "push" })}
    />
  );
}
